import axiosInstance from '../axiosInterceptor/axiosInstance'

const resumeLivestream = async (broadcastId, orgId) => {
  const url = `v1/orgs/${orgId}/streams/${broadcastId}/resume`
  return axiosInstance.post(url, {})
}

export default resumeLivestream
